<template>
  <div class="wrapper">
    <public-title headline="标题" author="作者" antistop="内容" periodical="期刊" @gotobtn="btn" :periodicalarrs="periodicalarr" @gotoinquire="eventinquire" :isbtn="true" btnname="新增"
      icon="el-icon-plus">
    </public-title>

    <div class="content">
     
      <el-table :data="tabledata" style="width: 100%" @sort-change="sortChange">
        <el-table-column prop="title" label="标题" align="center">
        </el-table-column>
        <el-table-column prop="subtitle" label="副标题" width="180" align="center">
        </el-table-column>
        <el-table-column prop="author" label="作者" align="center" sortable="custom">
        </el-table-column>
        <el-table-column prop="columnName" label="栏目" align="center" sortable="custom">
        </el-table-column>
        <el-table-column prop="periodicalDate" label="期刊号" align="center" sortable="custom">
        </el-table-column>
        <el-table-column prop="pagination" label="页码" align="center" sortable="custom">
        </el-table-column>
        <el-table-column label="操作" width="250" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" style="background: #014196;border-color: #014196;" @click="onLook(scope.$index, scope.row)">查看</el-button>
            <el-button size="mini" type="primary" @click="edit(scope.$index, scope.row)">修改</el-button>
            <!-- <el-popconfirm icon="el-icon-info" v-model="DelVisible" confirmButtonText='确定' cancelButtonText='取消'
              @onConfirm="handleDelete(scope.$index, scope.row)" iconColor="red" style="margin-left: 10px;"
              title="您确定要删除这一条记录吗？"> -->
              <el-button slot="reference" size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            <!-- </el-popconfirm> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[15, 30, 40, 50]" :page-size="100" layout="total, sizes, prev, pager, next, jumper"
        :total="totals">
      </el-pagination>
    </div>

    <el-drawer
      :visible.sync="drawer"
      :with-header="false">
      <div class="htmldiv">
        <div class="testtitle">{{testtitle}}</div>
        <div class="assisttitle">{{assisttitle}}</div>
        <div v-if="authortip" class="assisttitle">作者：{{authortip}}</div>
        <div v-html="test"></div>
      </div>
    </el-drawer>

    <el-dialog :title="issubbtn?'新增文章':'修改文章'" 
    :before-close="handleClose" 
    :visible.sync="dialogVisible" width="50%"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    >
     <!-- :close-on-click-modal="false"  默认点遮罩不关闭 -->
      <span class="recognition" @click="recognition()">导入识别</span>
      <div style="text-align: right;float: right;margin-top: -15px;display: inline;">
        <el-button type="primary" @click="onSubmit('form')">发布</el-button>
        <el-button v-if="issubbtn" type="primary" @click="alwaysSubmit('form')">继续发布</el-button>
        <el-button @click="dialogVisible = false">取消</el-button>
      </div>
      <el-form ref="form" :model="subform" :rules="rules" label-width="80px" >
        <el-form-item label="期刊号" prop="periodicalYear" style="width:50%;display: inline-block;">
          <el-select v-model="subform.periodicalYear" clearable filterable  @change="yearChange" placeholder="请选择" style="width:60%;">
            <el-option
              v-for="item in periodicalYeararr"
              :key="item.year"
              :label="item.year"
              :value="item.year"
              >
            </el-option>
          </el-select>
          <!-- v-model="subform.periodicalMonthid" -->
          <el-select v-model="subform.periodicalMonthid" @change="periodicalMonthid" style="width:40%;float: right;">
            <el-option
              v-for="item in periodicalMontharr"
              :key="item.id"
              :label="item.month"
              :value="item.id"
              >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="来源" prop="source" style="width:50%;display: inline-block;">
          <el-select v-model="subform.source" clearable filterable placeholder="请选择" @change="source" style="width:100%;">
            <el-option
              v-for="item in sourcearr"
              :key="item.value"
              :label="item.name"
              :value="item.value"
              >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="标题" prop="headline">
          <el-input v-model="subform.headline" placeholder="请输入标题"></el-input>
        </el-form-item>

        <el-form-item label="副标题" prop="subheading">
          <el-input v-model="subform.subheading" placeholder="请输入副标题"></el-input>
        </el-form-item>

        <el-form-item label="栏目" prop="column">
          <el-select v-model="subform.column" clearable filterable placeholder="请选择" @change="column" style="width:100%;">
            <el-option
              v-for="item in columnarr"
              :key="item.id"
              :label="item.columnName"
              :value="item.id"
              >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="作者" prop="author">
          <el-input v-model="subform.author" placeholder="请输入作者"></el-input>
        </el-form-item>

        <el-form-item label="作者单位" prop="unit">
          <el-input v-model="subform.unit" placeholder="请输入作者单位"></el-input>
        </el-form-item>

        <el-form-item label="原文页面" prop="homepage" >
          <el-input v-model.number="subform.homepage" style="width:40%;" placeholder="首页" @keyup.native="proving"></el-input>
          <el-input v-model.number="subform.trailerpage" style="width:45%;float: right;"  placeholder="尾页"></el-input>
        </el-form-item>


        <el-form-item label="文章内容"  prop="msg" >
          <!-- <tinymce-editor ref="editor"
          v-model="subform.msg"
          :class="ismsgstyle?'msgstyle':''"
          :disabled="disabled"
          @onClick="onClick">
          </tinymce-editor> -->
          <!-- <button @click="clear">清空内容</button>
          <button @click="disabled = true">禁用</button> -->
          <!-- <ckeditor :editor="editor" v-model="subform.msg" @ready="onReady" :config="editorConfig"></ckeditor> -->
          <tinymce-editor :formats="subform.msg" @isfalsedata="falsedata" id="editor"></tinymce-editor>
          <!-- <quill-editor :formats="subform.msg" @isfalsedata="falsedata" id="editor"></quill-editor> -->
        </el-form-item>


      </el-form>
    </el-dialog>

    <el-dialog title="导入识别" :before-close="handleClose1" :visible.sync="dialogVisible1" width="50%" :modal-append-to-body="false">
        <!-- <tinymce-editor ref="editor"
        v-model="msg1"
        :subforms='subform'
        :isalerts='isalert'
        :disabled="disabled"
        @onClick="onClick">
      </tinymce-editor> -->
      <tinymce-editor @istruedata="truedata" :formats="format" :isalerts='isalert'></tinymce-editor>
      <!-- <quill-editor @istruedata="truedata" :formats="format" :isalerts='isalert'></quill-editor> -->
    </el-dialog>

  </div>
</template>
<script>
  import publicTitle from '../../../components/publicTitle'
  import tinymceEditor from '../../../components/tinymce-editor.vue'
  // import quillEditor from '../../../components/quill-editor.vue'
  export default {
    // components: { publicTitle,tinymceEditor,quillEditor},
    components: { publicTitle,tinymceEditor},
    props: {},
    data() {
      var periodicalYear1 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error("请选择期刊号年"));
        } else if(this.subform.periodicalMonth=='') {
          callback(new Error("请选择期刊号月"));
        }else{
          callback();
        }
      };
      var homepage1 = (rule, value, callback) => {
        console.log(typeof(value),typeof(this.subform.trailerpage),'1111111')
        var reg = /^[1-9]\d*$/;
        console.log(reg.test(value),'22222222')
        if (value === '') {
          callback(new Error("请填写原文首页"));
        } else if(this.subform.trailerpage=='') {
          callback(new Error("请填写原文尾页"));
        } else if(reg.test(value) == false || reg.test(this.subform.trailerpage) == false){
          callback(new Error("页码必须为正整数"));
        }else if(value>this.subform.trailerpage){
          callback(new Error("尾页不能小于首页"));
        }else{
          callback();
        }
      };
      var msg1 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error("请填写文章内容"));
          this.ismsgstyle = true
        }else{
          callback();
          this.ismsgstyle = false
        }
      };
      return {

        disabled: false,
        msg1:'',
        format:``,
        tabledata: [],
        currentPage: 1,
        pageSize: 15,
        pageIndex: 1,
        totals: 0,
        form: {},
        subform:{
          periodicalYear:'', //期刊年
          periodicalMonth:'',//期刊月
          periodicalMonthid:'', //期刊id
          source:'', //来源
          sourcename:'',//来源nama
          headline:'', //标题
          subheading:'',//副标题
          column:'',//栏目
          columnname:'',//栏目name
          author:'',//作者
          unit:'',//单位
          homepage:'',//原文首页
          trailerpage:'',//原文尾页
          msg:'',//内容
          date:'',//期刊号 年月
          editdata:{}
        },
        DelVisible: false,
        dialogVisible: false,
        dialogVisible1: false,
        rules: {
          source: [
            { required: true, message: '请选择来源', trigger: 'change' },
          ],
          headline: [
            { required: true, message: '请输入标题', trigger: ['change','blur'] },
          ],
          // subheading: [
          //   { required: true, message: '请输入副标题', trigger: ['change','blur'] },
          // ],
          column: [
            { required: true, message: '请选择栏目', trigger: 'change' },
          ],
          // author: [
          //   { required: true, message: '请输入作者', trigger: ['change','blur'] },
          // ],
          // unit: [
          //   { required: true, message: '请输入作者单位', trigger: ['change','blur'] },
          // ],
          msg: [
            {required: true,  validator: msg1, trigger: 'blur' },
          ],
          periodicalYear: [
            {required: true,  validator: periodicalYear1, trigger:['change','blur'] }
          ],
          homepage: [
            {required: true, validator: homepage1, trigger: ['change','blur'] }
          ],
        },
        issubbtn:false, // edit fals - add true
        periodicalarr:[],
        periodicalYeararr:[],  //期刊年arr
        periodicalMontharr:[], //期刊月arr
        sourcearr:[], //来源
        columnarr:[],//栏目
        isalert:null, //富文本内容开关
        ismsgstyle:false, //富文本验证开关
        sortName:"",//排序名称
        sortType:"",//排序升序降序
        test:'',//查看文章
        testtitle:'',//title
        authortip:'', //作者
        assisttitle:'', //副标题
        drawer: false,//抽屉
      };
    },
    watch:{
      'subform.periodicalYear': {
            deep: true,
            handler: function (val){
                this.$http({
                  url: this.$api.periodicalmonth + `?year=${val}`,
                  method: "GET",
                }).then(res => {
                  if (res.data.code == 200) {
                    this.periodicalMontharr = res.data.data;
                    // console.log("月份",this.periodicalMontharr)
                  }else{
                    this.$toast("error", res.data.msg);
                  }
                })
            }
        },
        'subform.msg':{
          deep:true,
          handler:function(val){
            // console.log("subform.msg",val) //富文本值 
            if(this.ismsgstyle){
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                      this.ismsgstyle = false
                    }else{
                      return false;
                    }
                });
            }
          }
        }
    },

    mounted() {
      
      this.alertdata()
      this.updata()
    },
    methods: {
      isNumber(val) {
    var regPos = /^\d+(\.\d+)?$/; //非负浮点数
    var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
    if(regPos.test(val) || regNeg.test(val)) {
        return true;
        } else {
        return false;
        }
    },
    unescape:function (html) {
        var s = ""; 
        if (html.length == 0) return "";
        s = html.replace(/&amp;/g, "&");
        s = s.replace(/&lt;/g, "<");
        s = s.replace(/&gt;/g, ">");
        s = s.replace(/&nbsp;/g, " ");
        s = s.replace(/&#39;/g, "\'");
        s = s.replace(/&quot;/g, "\"");
        s = s.replace(/<br\/>/g, "\n");
        // this.test = s; //赋值给数据  保存的时候取值
        return s; 
      },
    //查看文章
    onLook(index, item){
      this.drawer = true;

        this.$http({
        url:this.$api.articlehtml + `/${item.id}`,
        method:"GET",
      }).then(res => {
        if(res.data.code === 200){
            let list =  res.data.data.content;//富文本
            let title = res.data.data.title;//标题
            let assisttitle = res.data.data.subtitle; //副标题
            this.test = this.unescape(list);
            this.testtitle = this.unescape(title);
            this.assisttitle = this.unescape(assisttitle);
            this.authortip = res.data.data.author;//作者
          }else{ 
            return false
          }
          

        })
      
    
      
    },
    //首页输入 控制尾页  默认首页和尾页一致  用户可自行修改
    proving(e){
      let boolean = e.target.value;
      if(!boolean){
        e.target.value = '';
      }else{
        this.subform.trailerpage = this.subform.homepage;
      }
    },
      falsedata(data){
        //会重复判断  不能写方法
        this.subform.msg = data;//传给后台的富文本
        // console.log("this.subform.msg",this.subform.msg)
      },
      truedata(data){
        this.dialogVisible1 = false
        this.isalert = false
        this.subform.headline = data.headline
        // this.subform.subheading = data.subheading
        // this.subform.author = data.author
        // this.subform.unit = data.unit
        this.subform.homepage = data.homepage
        this.subform.trailerpage = data.trailerpage
        this.subform.msg = data.msg
      },
    //来源
    source(val){
      let obj = {};
      obj = this.sourcearr.find((item)=>{
        return item.value === val;
      });
      this.subform.sourcename = obj.name;
    },
    //栏目
    column(val){
      let obj = {};
      obj = this.columnarr.find((item)=>{
        return item.id === val;
      });
      this.subform.columnname = obj.columnName;
      console.log("this.subform.columnname",this.subform.columnname)
    },
    //
    // 期刊年的变化
    yearChange(val){
    
        this.subform.periodicalMonthid = "";
        this.periodicalMontharr = "";
        this.subform.periodicalMonth  = "";
      

    },
    //期刊月
    periodicalMonthid(val){
      let obj = {};
      obj = this.periodicalMontharr.find((item)=>{
        return item.id === val;
      });
      this.subform.periodicalMonth = obj.month;
    },
    //导入识别
    recognition(){
      this.dialogVisible1 = true
      this.subform.date = this.subform.periodicalYear+'-'+this.subform.periodicalMonth
      this.isalert = true
      /* if(typeof(this.subform.homepage)=='number'){
        console.log(typeof(this.subform.homepage),'shuzi')
        this.subform.homepage = this.subform.homepage.toString()
      }else{
        console.log(typeof(this.subform.homepage),'不是')
      } */
      // <p>副标题</p>
      // <p>=&gt;${this.subform.subheading}</p>
      // <p>作者</p>
      // <p>=&gt;${this.subform.author}</p>
      // <p>作者单位</p>
      // <p>=&gt;${this.subform.unit}</p>
      this.format = `<p>标题</p>
                <p>=&gt;${this.subform.headline}</p>
                <p>原文页面首页</p>
                <p>=&gt;${this.subform.homepage}</p>
                <p>原文页面尾页</p>
                <p>=&gt;${this.subform.trailerpage}</p>
                <p>文章内容</p>
                <p>&lt;=</p>
                <span>${this.subform.msg}</span>
                <p>&lt;=</p>
                `
      // console.log(this.subform,'1111')
      // console.log(this.format,'2222')
    },
    //文章管理列表
      updata(pageIndex = 1, pageSize = 15, Vperiodical = '',Vheadline = '',Vauthor = '',Vantistop = '') {
        
        if(this.sortType == null){
          this.sortType = "";
          this.sortName = "";
        }
        let sortType = this.sortType;
        let sortName =this.sortName;
        this.$http({
          url: this.$api.articlelist + `?pageIndex=${pageIndex}&pageSize=${pageSize}&pdfId=${Vperiodical}&title=${Vheadline}&author=${Vauthor}&keyWords=${Vantistop}&sortName=${sortName}&sortType=${sortType}`,
          method: "GET",
        }).then(res => {
          if (res.data.code == 200) {
            this.tabledata = res.data.data.records
            this.pageSize = res.data.data.size
            this.currentPage = res.data.data.current
            this.totals = res.data.data.total
            // this.data.sortType = "";
            // this.data.sortName = "";
          }else{
            this.$toast("error", res.data.msg);
          }
        });
      },
      eventinquire(form) {
        console.log("搜索栏方法",form)
        this.form = form
        this.updata(1, this.pageSize, this.form.Vperiodical,this.form.Vheadline,this.form.Vauthor,this.form.Vantistop)
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.updata(this.pageIndex, this.pageSize,this.form.Vperiodical,this.form.Vheadline,this.form.Vauthor,this.form.Vantistop)
      },
      handleCurrentChange(val) {
        this.pageIndex = val
        this.updata(this.pageIndex, this.pageSize,this.form.Vperiodical,this.form.Vheadline,this.form.Vauthor,this.form.Vantistop)
      },
      //修改
      edit(index, item) {
        console.log(item)
        this.dialogVisible = true;
        this.issubbtn = false
        this.$http({
          url: this.$api.articleinfo + `/${item.id}`,
          method: "GET",
        }).then(res => {
          if (res.data.code == 200) {
            this.editdata = res.data.data
            console.log("获取修改内容",this.editdata.content)
            this.subform.headline = this.editdata.title
            this.subform.subheading = this.editdata.subtitle
            this.subform.author = this.editdata.author
            this.subform.unit = this.editdata.authorDept
            this.subform.homepage = this.editdata.pagination.split('-')[0]-0
            this.subform.trailerpage = this.editdata.pagination.split('-')[1]-0
            if(this.editdata.periodicalDate != null){
              console.log("期刊年月",this.editdata.periodicalDate)
              this.subform.periodicalYear = this.editdata.periodicalDate.split('-')[0]
              this.subform.periodicalMonth = this.editdata.periodicalDate.split('-')[1]
            }
            this.subform.msg = this.editdata.content
            this.subform.column = this.editdata.columnId
            this.subform.source = this.editdata.articlesSource
            this.subform.periodicalMonthid = this.editdata.pdfId
            console.log("this.subform.periodicalMonthid",this.subform.periodicalMonthid)
            console.log("富文本的内容",this.subform.msgm)
          }else{
            this.$toast("error", res.data.msg);
          }
        })
      },
      alertdata(){
        //弹窗下拉期刊年接口
        this.$http({
          url: this.$api.periodicalyear,
          method: "GET",
        }).then(res => {
          if (res.data.code == 200) {
            this.periodicalYeararr = res.data.data
          }else{
            this.$toast("error", res.data.msg);
          }
        })
        //来源
        this.$http({
          url: this.$api.dictlist + `?type=articlesSource`,
          method: "GET",
        }).then(res => {
          if (res.data.code == 200) {
            this.sourcearr = res.data.data
          }else{
            this.$toast("error", res.data.msg);
          }
        })
        //栏目
        this.$http({
          url: this.$api.columnlist,
          method: "GET",
        }).then(res => {
          if (res.data.code == 200) {
            this.columnarr = res.data.data
          }else{
            this.$toast("error", res.data.msg);
          }
        })
        this.$http({
          url: this.$api.periodicalselectlist,
          method: "GET",
        }).then(res => {
          if (res.data.code == 200) {
            this.periodicalarr = res.data.data
          }else{
            this.$toast("error", res.data.msg);
          }
        })
      },
      //新增按钮触发清除
      btn(){
            this.subform.headline = ''
            this.subform.subheading = ''
            this.subform.author = ''
            this.subform.unit = ''
            this.subform.homepage = ''
            this.subform.trailerpage = ''
            this.subform.periodicalYear = ''
            this.subform.periodicalMonth = ''
            this.subform.msg = ''
            this.subform.column = '' //请空栏目
            // this.subform.source = '' //清空来源
            this.subform.source = "1" //来源
            this.subform.periodicalMonthid = ''

        this.dialogVisible = true
        this.issubbtn = true
      },
      //删除 update:qyl 2020/3/7 增加删除提示
      handleDelete(index, item) {
        this.$confirm("您确定要删除这一条记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$http({
          url: this.$api.articledel + `${item.id}`,
          method: "DELETE",
        }).then(res => {
          if (res.data.code == 200) {
            this.$toast("success", res.data.msg);
            // this.updata(1, this.pageSize);
            this.updata(this.pageIndex, this.pageSize, this.form.Vperiodical,this.form.Vheadline,this.form.Vauthor,this.form.Vantistop)
          }else{
            this.$toast("error", res.data.msg);
          }
          this.DelVisible = false
        });
      })
      },
      //保存文章
      onSubmit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let userId = JSON.parse(sessionStorage.getItem("userinfo")).id
            if(this.issubbtn){
              let data = {
                userId,//用户id
                pdfId:this.subform.periodicalMonthid,//期刊id
                title:this.subform.headline,//标题
                subtitle:this.subform.subheading,//副标题
                author:this.subform.author,//作者
                authorDept:this.subform.unit,//单位
                pagination:this.subform.homepage+'-'+this.subform.trailerpage,//页码
                periodicalDate:this.subform.periodicalYear+'-'+this.subform.periodicalMonth,//期刊号
                columnId:this.subform.column,//栏目id
                columnName:this.subform.columnname,//栏目名称
                content:this.subform.msg,//内容
                articlesSource:this.subform.source,//文章来源
                articlesSourceName:this.subform.sourcename//文章来源名称
              }
              this.$http({
                url: this.$api.articlesave,
                method: "POST",
                data
              }).then(res => {
                if (res.data.code == 200) {
                  this.$toast("success", res.data.msg);
                  this.updata(1, this.pageSize,this.form.Vperiodical,this.form.Vheadline,this.form.Vauthor,this.form.Vantistop)
                  this.dialogVisible = false
                  this.$refs['form'].resetFields();//清空表单
                }else{
                  this.$toast("error", res.data.msg);
                }
              })
            } else {
              console.log('修改')
              let data = {
                userId,//用户id
                id:this.editdata.id,//文章id
                pdfId:this.subform.periodicalMonthid,//期刊id
                title:this.subform.headline,//标题
                subtitle:this.subform.subheading,//副标题
                author:this.subform.author,//作者
                authorDept:this.subform.unit,//单位
                pagination:this.subform.homepage+'-'+this.subform.trailerpage,//页码
                periodicalDate:this.subform.periodicalYear+'-'+this.subform.periodicalMonth,//期刊号
                columnId:this.subform.column,//栏目id
                columnName:this.subform.columnname,//栏目名称
                content:this.subform.msg,//内容
                articlesSource:this.subform.source,//文章来源
                articlesSourceName:this.subform.sourcename//文章来源名称
              }
              this.$http({
                url: this.$api.articleupdate,
                method: "PUT",
                data
              }).then(res => {
                if (res.data.code == 200) {
                  this.$toast("success", res.data.msg);
                  this.updata(this.pageIndex, this.pageSize, this.form.Vperiodical,this.form.Vheadline,this.form.Vauthor,this.form.Vantistop)
                  this.dialogVisible = false
                  this.$refs['form'].resetFields();
                }else{
                  this.$toast("error", res.data.msg);
                }
              })
            }
          } else {
            return false;
          }
        });
      },
      //连续发布
      alwaysSubmit(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let userId = JSON.parse(sessionStorage.getItem("userinfo")).id
            if(this.issubbtn){
              let data = {
                userId,//用户id
                pdfId:this.subform.periodicalMonthid,//期刊id
                title:this.subform.headline,//标题
                subtitle:this.subform.subheading,//副标题
                author:this.subform.author,//作者
                authorDept:this.subform.unit,//单位
                pagination:this.subform.homepage+'-'+this.subform.trailerpage,//页码
                periodicalDate:this.subform.periodicalYear+'-'+this.subform.periodicalMonth,//期刊号
                columnId:this.subform.column,//栏目id
                columnName:this.subform.columnname,//栏目名称
                content:this.subform.msg,//内容
                articlesSource:this.subform.source,//文章来源
                articlesSourceName:this.subform.sourcename//文章来源名称
              }
              this.$http({
                url: this.$api.articlesave,
                method: "POST",
                data
              }).then(res => {
                if (res.data.code == 200) {
                  this.$toast("success", res.data.msg);
                  // this.updata(1, this.pageSize) //刷新页面
                  this.updata(this.pageIndex, this.pageSize, this.form.Vperiodical,this.form.Vheadline,this.form.Vauthor,this.form.Vantistop)
                  // this.dialogVisible = false 关闭弹窗
                  this.subform.periodicalMonthid = ""; //清除页面 月份id数据
                  this.subform.trailerpage = "";//清空尾页
                  // this.$refs['form'].resetFields();//清空表单
                  this.subform.headline = ''
                  this.subform.subheading = ''
                  this.subform.author = ''
                  this.subform.unit = ''
                  this.subform.homepage = ''
                  this.subform.periodicalYear = ''
                  this.subform.periodicalMonth = ''
                  this.subform.msg = ''
                  // this.subform.column = '' //请空栏目
                  // this.subform.source = '' //清空来源
                  // this.subform.source = ''
                }else{
                  this.$toast("error", res.data.msg);
                }
              })
            } else {
              let data = {
                userId,//用户id
                id:this.editdata.id,//文章id
                pdfId:this.subform.periodicalMonthid,//期刊id
                title:this.subform.headline,//标题
                subtitle:this.subform.subheading,//副标题
                author:this.subform.author,//作者
                authorDept:this.subform.unit,//单位
                pagination:this.subform.homepage+'-'+this.subform.trailerpage,//页码
                periodicalDate:this.subform.periodicalYear+'-'+this.subform.periodicalMonth,//期刊号
                columnId:this.subform.column,//栏目id
                columnName:this.subform.columnname,//栏目名称
                content:this.subform.msg,//内容
                articlesSource:this.subform.source,//文章来源
                articlesSourceName:this.subform.sourcename//文章来源名称
              }
              this.$http({
                url: this.$api.articleupdate,
                method: "PUT",
                data
              }).then(res => {
                if (res.data.code == 200) {
                  this.$toast("success", res.data.msg);
                  this.updata(this.pageIndex, this.pageSize, this.form.Vperiodical,this.form.Vheadline,this.form.Vauthor,this.form.Vantistop)
                  // this.dialogVisible = false //关闭dialog弹窗
                  this.subform.periodicalMonthid = ""; //清空 页面月份id数据
                  this.subform.trailerpage = "";//清空尾页
                  this.$refs['form'].resetFields();
                }else{
                  this.$toast("error", res.data.msg);
                }
              })
            }
          } else {
            return false;
          }
        });
      },
      //点X关闭
      handleClose1(done) {
        this.dialogVisible1 = false;
        this.isalert = false
      },
      handleClose(done) {
        this.dialogVisible = false;
        this.subform.periodicalMonthid = ''
        this.subform.trailerpage = ''
        this.ismsgstyle = false
        this.$refs['form'].resetFields();
      },
      //排序方法sortName 是对应的属性  sortType是desc(降序)或asc(升序)
       sortChange (column, event) {
         console.log("column")
        this.sortName = column.prop;
        this.sortType = column.order;
        // if(column.order =='ascending'){
        //   this.sortType = 'asc'
        //   }else if(column.order =='descending'){
        //     this.sortType = 'desc'
        //     }else{
        //       this.sortType = ''
        //       };
        this.updata(this.pageIndex, this.pageSize, this.form.Vperiodical,this.form.Vheadline,this.form.Vauthor,this.form.Vantistop)
      
    },
   
    },
    created() { },
    beforeDestroy() { }
  };
</script>

<style lang="scss" scoped>
//富文本样式改变
// /deep/.ck.ck-editor__editable_inline>p{
//       margin-top: var(--ck-spacing-large);
//       text-indent:2em;
// }
  .role-select {
    width: 290px !important;
  }

  .content {
    background: #fff;
    width: 100%;
    height:100%;
    // overflow: auto;
  }
  .testtitle{
    font-size: 20px;
  }
  .assisttitle{
    font-size: 14px;
    line-height: 30px;
  }
  .htmldiv{
    padding: 0 2%;
    height: 89vh;
    overflow: auto;
    font-size: 16px;
    .image{
      margin:auto;
      text-align: center;
      object-fit: fill;
    }

    img{
      width:100%;
      object-fit: fill;
    }
  }
  figure {
    display: block;
    margin-block-start: 0em;
    margin-block-end: 0em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    img {
    width: 100%;
    border-style: none;
}
}

  /deep/.el-pagination {
    text-align: center;
    padding-bottom: 10px;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ffffff;
  }
  .recognition{
    width: 80px;
    display: inline-block;
    text-align: right;
    font-size: 14px;
    color: #606266;
    line-height: 40px;
    padding: 0 12px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #C00000;
    cursor: pointer;
  }
  .msgstyle{
    border:1px solid #F56C6C;
  }
  .wrapper{
    // height: 100%;
    height: calc(100vh - 2.3rem); //解决头部被文章过长 导致 头部被挤上去的问题
  }
  /deep/.el-table{
    height: 100%;
      // overflow-x: scroll;
}
/deep/.el-table::before{
  background-color: none;
  opacity:0;
}
/deep/.el-table__body-wrapper{ 
    height:62vh;
    // margin-bottom: 7%;
    // padding-bottom: 5%;
    overflow-y: auto;
}
/deep/.el-table th>.cell{
  color: #000;
}
.el-table__header-wrapper{
  position:fixed;
  top:0;
}
</style>